<template>
    <v-navigation-drawer id="sidebar" v-if="authorized" app permanent right floating  width="440"
        :color="this.$vuetify.theme.dark ? '#000000' : '#ffffff'" clipped>
        <v-card flat class="fill-height d-flex flex-column rounded-xl">
            <v-card-title>
                <v-icon left>mdi-chat</v-icon>
                {{ $t("ASK") }}
            </v-card-title>
            <v-list class="drawer-scroll-area">
                <v-list-item v-for="(item, i) in chatQuestions" :key="i">
                    <v-list-item-content>
                        <v-list-item-subtitle>
                            {{ item }}
                        </v-list-item-subtitle>
                        <br>
                        <VueShowdown :markdown="chatAnswers[i]"/>
                    </v-list-item-content>
                </v-list-item>
                <v-card-text v-if="processing">
                    <v-progress-linear indeterminate color="green"></v-progress-linear>
                </v-card-text>
            </v-list>
            <v-card-actions class="drawer-input-area">
                <v-text-field v-model="form.message" :label="$t('ASK')" outlined large hide-details="auto"
                    append-icon="mdi-send" @keydown.enter="sendMessage()" @click:append="sendMessage()"></v-text-field>
            </v-card-actions>
        </v-card>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: "AgentBar",
    data() {
        return {
            form: {},
            processing: false,
            chatQuestions: [],
            chatAnswers: []
        };
    },
    computed: {
        authorized() {
            return this.$store.state.authorized;
        }
    },
    methods: {
        async sendMessage() {
            this.processing = true;
            try {
                const response = await this.$store.dispatch("post", {
                    endpoint: `documents/chat`,
                    form: this.form
                });

                this.chatQuestions.push(this.form.message);
                this.chatAnswers.push(response.data);
                this.form = {};
           
            } catch (error) {
                this.error = true;
                this.errorDescription = error.response?.data?.errorDescription ?? 'An unknown error occurred';
            } finally {
                this.processing = false;
            }
        }
    }
}

</script>

<style scoped>

.fill-height.d-flex.flex-column {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.drawer-scroll-area {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0; 
  padding-bottom: 8px;
}

.drawer-input-area {
  flex-shrink: 0;
  padding-bottom: 8px;
  background: transparent;
}

</style>

<i18n>
{
  "en": {
    "HOME" : "Home",
    "WELCOME" : "Welcome",
    "ASK" : "Ask Connxions",
    "SEND" : "Send"
  }
}
</i18n>